import React from 'react';
import PropTypes from 'prop-types';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils, { formatDate, parseDate } from 'react-day-picker/moment';
import 'moment/locale/fr';

const SelecteurDate = ({ label, valeurDate, onDayChange }) => (
    <span>
        {label && <span className="col-form-label mr-1">{label}</span>}
        <DayPickerInput
            inputProps={{ className: 'form-control' }}
            formatDate={formatDate}
            parseDate={parseDate}
            format="L"
            value={`${formatDate(new Date(valeurDate), 'L', 'fr')}`}
            placeholder="JJ/MM/AAAA"
            onDayChange={onDayChange}
            dayPickerProps={{
                locale: 'fr',
                localeUtils: MomentLocaleUtils,
            }}
        />
    </span>
);

SelecteurDate.defaultProps = {
    label: undefined,
};

SelecteurDate.propTypes = {
    label: PropTypes.string,
    valeurDate: PropTypes.object.isRequired,
    onDayChange: PropTypes.func.isRequired,
};

export default SelecteurDate;



// WEBPACK FOOTER //
// ./src/components/SelecteurDate.js